import { render } from "./TwoLineSection.vue?vue&type=template&id=5f063d4c"
import script from "./TwoLineSection.vue?vue&type=script&lang=js"
export * from "./TwoLineSection.vue?vue&type=script&lang=js"

import "./TwoLineSection.vue?vue&type=style&index=0&id=5f063d4c&lang=css"
script.render = render

export default script